(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-header"] && !Shopify.designMode) return;
  try {
    
  class KaHeaderRoot extends HTMLElement {
    connectedCallback() {
      this.burger = this.querySelector('[data-ka-burger]');
      this.overlay = this.querySelector('[data-ka-overlay]');
      this.closeBtn = this.querySelector('[data-ka-close]');
      this.lang = this.querySelector('[data-ka-lang]');

      this.onDocClick = (event) => {
        if (this.lang && this.lang.open && !this.lang.contains(event.target)) this.lang.open = false;
      };
      document.addEventListener('click', this.onDocClick);

      this.onKeydown = (event) => {
        if (event.key === 'Escape') {
          if (this.lang && this.lang.open) this.lang.open = false;
          if (this.isOpen()) this.close();
        }
      };
      document.addEventListener('keydown', this.onKeydown);

      if (!this.burger || !this.overlay) return;

      this.onMql = (event) => {
        if (event.matches) this.close();
      };

      this.burger.addEventListener('click', () => {
        this.isOpen() ? this.close() : this.open();
      });
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      this.overlay.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.close());
      });

      this.mql = window.matchMedia('(min-width: 990px)');
      this.mql.addEventListener('change', this.onMql);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('click', this.onDocClick);
      if (this.mql) this.mql.removeEventListener('change', this.onMql);
      this.unlockScroll();
    }

    isOpen() {
      return this.overlay && !this.overlay.hidden;
    }

    open() {
      this.overlay.hidden = false;
      this.burger.setAttribute('aria-expanded', 'true');
      this.lockScroll();
      (this.closeBtn || this.overlay).focus();
    }

    close() {
      if (!this.isOpen()) return;
      this.overlay.hidden = true;
      this.burger.setAttribute('aria-expanded', 'false');
      this.unlockScroll();
      this.burger.focus();
    }

    lockScroll() {
      this.prevBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }

    unlockScroll() {
      document.body.style.overflow = this.prevBodyOverflow || '';
    }
  }

  if (!customElements.get('ka-header-root')) {
    customElements.define('ka-header-root', KaHeaderRoot);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ka-hero-typewriter')) {
    class KaHeroTypewriter extends HTMLElement {
      connectedCallback() {
        this.wordEl = this.querySelector('[data-ka-word]');
        this.dialectEl = this.querySelector('[data-ka-dialect]');
        this.meaningEl = this.querySelector('[data-ka-meaning]');
        this.pills = Array.prototype.slice.call(this.querySelectorAll('[data-ka-pill]'));
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.timer = null;
        this.index = 0;

        var dataEl = this.querySelector('[data-ka-words]');
        try {
          this.words = dataEl ? JSON.parse(dataEl.textContent) : [];
        } catch (e) {
          this.words = [];
        }

        var self = this;
        this.pills.forEach(function (pill) {
          pill.addEventListener('click', self.onPill.bind(self));
        });

        // prefers-reduced-motion: statisch beim (server-gerenderten) ersten Wort bleiben
        if (this.words.length > 1 && !this.reduced.matches) {
          this.timer = setTimeout(function () { self.cycle(); }, 2000);
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      setMeta(i) {
        var w = this.words[i];
        if (!w) return;
        this.dialectEl.textContent = w.dialect;
        this.meaningEl.textContent = w.meaning;
        this.pills.forEach(function (pill) {
          pill.classList.toggle('is-active', pill.getAttribute('data-ka-pill') === w.dialect);
        });
      }

      showInstant(i) {
        this.index = i;
        this.wordEl.textContent = this.words[i].word;
        this.setMeta(i);
      }

      cycle(targetIndex) {
        var self = this;
        var next = typeof targetIndex === 'number' ? targetIndex : (this.index + 1) % this.words.length;
        this.erase(function () {
          self.index = next;
          self.setMeta(next);
          self.timer = setTimeout(function () {
            self.type(self.words[next].word, 0, function () {
              self.timer = setTimeout(function () { self.cycle(); }, 2000); /* 2s Pause */
            });
          }, 400);
        });
      }

      erase(done) {
        var self = this;
        var current = this.wordEl.textContent;
        if (!current.length) { done(); return; }
        this.wordEl.textContent = current.slice(0, -1);
        this.timer = setTimeout(function () { self.erase(done); }, 45);
      }

      type(word, i, done) {
        var self = this;
        if (i >= word.length) { done(); return; }
        this.wordEl.textContent = word.slice(0, i + 1);
        this.timer = setTimeout(function () { self.type(word, i + 1, done); }, 90); /* ~90ms/Zeichen */
      }

      onPill(event) {
        var dialect = event.currentTarget.getAttribute('data-ka-pill');
        var target = -1;
        for (var step = 1; step <= this.words.length; step++) {
          var i = (this.index + step) % this.words.length;
          if (this.words[i].dialect === dialect) { target = i; break; }
        }
        if (target < 0) return;
        clearTimeout(this.timer);
        if (this.reduced.matches) {
          this.showInstant(target);
          return;
        }
        this.cycle(target);
      }
    }
    customElements.define('ka-hero-typewriter', KaHeroTypewriter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-live-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initKaLiveMain(root) {
      if (!root || root.dataset.kaLiveMainInit === 'true') return;
      root.dataset.kaLiveMainInit = 'true';

      var radios = root.querySelectorAll('.ka-live-main__cohort input[type="radio"]');
      var priceEl = root.querySelector('[data-ka-price]');

      function sync() {
        radios.forEach(function (radio) {
          var card = radio.closest('.ka-live-main__cohort');
          if (card) card.classList.toggle('is-active', radio.checked);
          if (radio.checked && priceEl && radio.dataset.price) {
            priceEl.textContent = radio.dataset.price;
          }
        });
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', sync);
      });
      sync();

      var bar = root.querySelector('[data-ka-sticky]');
      var booking = root.querySelector('[data-ka-booking]');
      if (bar && booking && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.classList.toggle('is-visible', passed);
          },
          { threshold: 0 }
        );
        observer.observe(booking);
      }
    }

    function initAll() {
      document.querySelectorAll('.ka-live-main').forEach(initKaLiveMain);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.ka-live-main');
      if (root) initKaLiveMain(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-main-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ka-main-product')) {
    customElements.define(
      'ka-main-product',
      class KaMainProduct extends HTMLElement {
        connectedCallback() {
          var variantsEl = this.querySelector('[data-ka-variants]');
          this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
          this.idInput = this.querySelector('[data-ka-id-input]');
          this.priceAmount = this.querySelector('[data-ka-price-amount]');
          this.selfPrice = this.querySelector('[data-ka-self-price]');
          this.submitBtn = this.querySelector('[data-ka-submit]');
          this.ctaText = this.querySelector('[data-ka-cta-text]');
          this.payment = this.querySelector('[data-ka-payment]');
          this.mainImage = this.querySelector('[data-ka-main-image]');
          this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-ka-thumb]'));
          this.bundles = Array.prototype.slice.call(this.querySelectorAll('[data-ka-bundle]'));
          this.optionInputs = Array.prototype.slice.call(this.querySelectorAll('[data-ka-option-input]'));
          this.langGroup = this.querySelector('[data-ka-lang-group]');
          this.langError = this.querySelector('[data-ka-lang-error]');
          this.payGuard = this.querySelector('[data-ka-pay-guard]');
          this.langCode = null;
          this.initialPrice = this.priceAmount ? this.priceAmount.textContent : '';

          this.mode = 'self';
          this.altCard = null;
          try {
            this.selectedOptions = JSON.parse(this.dataset.currentOptions || '[]');
          } catch (e) {
            this.selectedOptions = [];
          }
          /* E-Book-Sprache startet immer leer – auch bei ?variant= in der URL */
          if (this.langGroup) {
            this.langIndex = parseInt(this.langGroup.dataset.optionIndex, 10);
            this.selectedOptions[this.langIndex] = null;
          }
          this.currentVariant = this.matchVariant();

          this.initThumbs();
          this.initOptions();
          this.initBundles();
          this.initLangGuard();
        }

        /* ---------- Galerie ---------- */
        initThumbs() {
          var self = this;
          this.thumbs.forEach(function (btn) {
            btn.addEventListener('click', function () {
              self.showMedia(btn);
            });
          });
          var more = this.querySelector('[data-ka-more]');
          if (more) {
            more.addEventListener('click', function () {
              self.thumbs.forEach(function (t) {
                t.classList.remove('is-hidden');
              });
              more.classList.add('is-hidden');
            });
          }
        }

        showMedia(btn) {
          if (!this.mainImage || !btn) return;
          this.mainImage.src = btn.dataset.fullSrc;
          this.mainImage.srcset = btn.dataset.fullSrcset || '';
          if (btn.dataset.width && btn.dataset.height) {
            this.mainImage.setAttribute('width', btn.dataset.width);
            this.mainImage.setAttribute('height', btn.dataset.height);
          }
          this.mainImage.alt = btn.dataset.alt || '';
          this.thumbs.forEach(function (t) {
            t.classList.toggle('is-current', t === btn);
          });
        }

        /* ---------- Variant-Picker ---------- */
        initOptions() {
          var self = this;
          this.optionInputs.forEach(function (input) {
            input.addEventListener('change', function () {
              self.onOptionChange(input);
            });
          });
        }

        onOptionChange(input) {
          var group = input.closest('[data-ka-option-group]');
          if (!group) return;
          var idx = parseInt(group.dataset.optionIndex, 10);
          this.selectedOptions[idx] = input.value;

          var pills = group.querySelectorAll('.ka-pill, .ka-main-product__lang-opt');
          Array.prototype.forEach.call(pills, function (pill) {
            pill.classList.remove('is-active');
          });
          var label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.add('is-active');

          if (group === this.langGroup) {
            /* Sprache gilt auch fuer eine gewaehlte Bundle-Karte -> Auswahl bleibt, Variante wird umgemappt */
            this.langCode = input.dataset.langCode || input.value;
            this.hideLangError();
            if (this.payGuard) this.payGuard.hidden = true;
            this.syncBundleLanguage();
          } else {
            /* Pills gelten nur fuers Seiten-Produkt -> zurueck auf "This book only" */
            this.mode = 'self';
            this.altCard = null;
          }
          this.currentVariant = this.matchVariant();
          this.syncBundleChecked();
          this.applyState();
        }

        matchVariant() {
          var selected = this.selectedOptions;
          var match = null;
          this.variants.forEach(function (v) {
            if (match) return;
            if (JSON.stringify(v.options) === JSON.stringify(selected)) match = v;
          });
          return match;
        }

        /* ---------- Pflicht: E-Book-Sprache ---------- */
        initLangGuard() {
          if (!this.langGroup) return;
          var self = this;
          var block = function (event) {
            if (self.langCode) return;
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            self.showLangError();
          };
          /* Capture-Phase: greift vor product-form.js (submit) und vor App-Click-Handlern */
          this.addEventListener(
            'click',
            function (event) {
              if (event.target.closest && event.target.closest('[data-ka-submit]')) block(event);
            },
            true
          );
          this.addEventListener('submit', block, true);
          if (this.payGuard) this.payGuard.addEventListener('click', block);

          /* Vom Browser wiederhergestellte Auswahl (Back-Navigation) uebernehmen */
          var restored = this.langGroup.querySelector('[data-ka-option-input]:checked');
          if (restored) this.onOptionChange(restored);
        }

        showLangError() {
          var group = this.langGroup;
          group.classList.remove('is-invalid');
          void group.offsetWidth; /* Shake-Animation bei jedem Versuch neu starten */
          group.classList.add('is-invalid');
          if (this.langError) this.langError.hidden = false;
          var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          group.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          var first = group.querySelector('[data-ka-option-input]');
          if (first) {
            try {
              first.focus({ preventScroll: true });
            } catch (e) {
              first.focus();
            }
          }
        }

        hideLangError() {
          if (!this.langGroup) return;
          this.langGroup.classList.remove('is-invalid');
          if (this.langError) this.langError.hidden = true;
        }

        /* ---------- Bundle-Switcher ---------- */
        initBundles() {
          var self = this;
          this.bundles.forEach(function (card) {
            card.addEventListener('click', function () {
              if (card.dataset.kaBundle === 'self') {
                self.mode = 'self';
                self.altCard = null;
              } else {
                self.mode = 'alt';
                self.altCard = card;
              }
              self.syncBundleChecked();
              self.applyState();
            });
          });
        }

        /* Bundle-Variante passend zur gewaehlten E-Book-Sprache; null = Sprache gibt es im Bundle nicht */
        bundleVariant(card) {
          var fallback = {
            id: card.dataset.variantId,
            price: card.dataset.price,
            available: card.dataset.available === 'true'
          };
          if (!this.langCode || !card.dataset.langVariants) return fallback;
          var map;
          try {
            map = JSON.parse(card.dataset.langVariants);
          } catch (e) {
            return fallback;
          }
          if (!map || !Object.keys(map).length) return fallback;
          return map[this.langCode] || null;
        }

        syncBundleLanguage() {
          var self = this;
          this.bundles.forEach(function (card) {
            if (card.dataset.kaBundle !== 'alt') return;
            var v = self.bundleVariant(card);
            card.classList.toggle('is-hidden', !v);
            if (v) {
              var price = card.querySelector('.ka-main-product__bundle-price');
              if (price) price.textContent = v.price;
            } else if (self.altCard === card) {
              self.mode = 'self';
              self.altCard = null;
            }
          });
        }

        syncBundleChecked() {
          var self = this;
          this.bundles.forEach(function (card) {
            var active =
              (self.mode === 'self' && card.dataset.kaBundle === 'self') ||
              (self.mode === 'alt' && card === self.altCard);
            card.classList.toggle('is-active', active);
            card.setAttribute('aria-checked', active ? 'true' : 'false');
          });
        }

        /* ---------- State -> Formular/Preis/CTA ---------- */
        applyState() {
          if (!this.idInput || !this.submitBtn) return;

          if (this.mode === 'alt' && this.altCard) {
            var bv = this.bundleVariant(this.altCard);
            if (bv) {
              this.idInput.value = bv.id;
              this.idInput.disabled = false;
              if (this.priceAmount) this.priceAmount.textContent = bv.price;
              this.setCta(bv.available);
              /* Dynamische Payment-Buttons gelten nur fuers Seiten-Produkt */
              if (this.payment) this.payment.classList.add('is-hidden');
              return;
            }
            this.mode = 'self';
            this.altCard = null;
            this.syncBundleChecked();
          }

          if (this.payment) this.payment.classList.remove('is-hidden');

          /* Noch keine E-Book-Sprache: Button bleibt klickbar (zeigt dann den Hinweis), nichts vorauswaehlen */
          if (this.langGroup && !this.langCode) {
            if (this.priceAmount) this.priceAmount.textContent = this.initialPrice;
            if (this.selfPrice) this.selfPrice.textContent = this.initialPrice;
            this.setCta(
              this.variants.some(function (variant) {
                return variant.available;
              })
            );
            return;
          }

          var v = this.currentVariant;
          if (!v) {
            this.setCta(false);
            return;
          }
          this.idInput.value = v.id;
          this.idInput.disabled = false;
          if (this.priceAmount) this.priceAmount.textContent = v.price;
          if (this.selfPrice) this.selfPrice.textContent = v.price;
          this.setCta(v.available);

          if (v.media_id) {
            var mediaThumb = null;
            this.thumbs.forEach(function (t) {
              if (!mediaThumb && t.dataset.mediaId === String(v.media_id)) mediaThumb = t;
            });
            if (mediaThumb) this.showMedia(mediaThumb);
          }

          if (this.dataset.updateUrl === 'true' && this.dataset.productUrl && window.history.replaceState) {
            window.history.replaceState({}, '', this.dataset.productUrl + '?variant=' + v.id);
          }
        }

        setCta(available) {
          if (!this.submitBtn || !this.ctaText) return;
          if (available) {
            this.submitBtn.removeAttribute('disabled');
            this.ctaText.textContent = this.dataset.ctaLabel;
          } else {
            this.submitBtn.setAttribute('disabled', '');
            this.ctaText.textContent = this.dataset.soldOutLabel;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  class KaVideoSlider extends HTMLElement {
    connectedCallback() {
      this.setupPosters();
      this.track = this.querySelector('[data-ka-track]');
      this.slides = Array.from(this.querySelectorAll('[data-ka-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-ka-dot]'));
      if (!this.track || this.slides.length < 2 || !this.dots.length) return;

      this.onDotClick = this.onDotClick.bind(this);
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }
    }

    setupPosters() {
      const posters = Array.from(this.querySelectorAll('[data-ka-vimeo]'));
      const loadThumb = (btn) => {
        if (btn.dataset.kaThumb) return;
        btn.dataset.kaThumb = '1';
        const id = btn.dataset.kaVimeo;
        const hash = btn.dataset.kaHash;
        const url = 'https://vimeo.com/' + id + (hash ? '/' + hash : '');
        fetch('https://vimeo.com/api/oembed.json?width=720&url=' + encodeURIComponent(url))
          .then((r) => (r.ok ? r.json() : null))
          .then((d) => {
            if (d && d.thumbnail_url) {
              const src = d.thumbnail_url.replace(/_\d+(x\d+)?(\.\w+)?$/, '_720x1280');
              btn.style.backgroundImage = 'url("' + src + '")';
            }
          })
          .catch(() => {});
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) { loadThumb(e.target); io.unobserve(e.target); }
          });
        }, { rootMargin: '400px' });
        posters.forEach((p) => io.observe(p));
      } else {
        posters.forEach(loadThumb);
      }
      posters.forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.kaVimeo;
          const hash = btn.dataset.kaHash;
          const iframe = document.createElement('iframe');
          iframe.className = 'ka-video-testimonials__iframe';
          iframe.src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?' + (hash ? 'h=' + encodeURIComponent(hash) + '&' : '') + 'autoplay=1&dnt=1&title=0&byline=0&portrait=0';
          iframe.title = btn.dataset.kaTitle || 'Video';
          iframe.width = 720;
          iframe.height = 1280;
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          iframe.setAttribute('allowfullscreen', '');
          btn.replaceWith(iframe);
        });
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.dots && this.onDotClick) {
        this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
      }
    }

    onDotClick(event) {
      const index = this.dots.indexOf(event.currentTarget);
      const slide = this.slides[index];
      if (!slide) return;
      const paddingLeft = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      const delta = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left - paddingLeft;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: reduce ? 'auto' : 'smooth' });
      this.setActive(index);
    }

    setActive(index) {
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('ka-video-slider')) {
    customElements.define('ka-video-slider', KaVideoSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
